import {
    GET_CLIENTS,
    GET_DETAIL_CLIENT,
    GET_STATE_LOADING
} from '@/views/clients/store/types/types.js'

const getters = {
    [GET_CLIENTS]: state => state.clients,
    [GET_DETAIL_CLIENT]: state => state.detailClient,
    [GET_STATE_LOADING]: state => state.loading,
}
export default getters;